import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 9/11;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 11 9" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.752 0L3.457 6.63.939 4.003l-.84.875 3.358 3.503L10.65.876z" fill={color} fillRule="nonzero"/>
    </svg>
)

export default class IconTick extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
